import Web3 from "web3";
import { allowToken, approveToken } from "@/contract";

/**
 * @returns {Promise<string|import("bn.js")>} allowance 原始值（wei 刻度由合约代币决定）
 */
export function readUsdtAllowanceForSellWine() {
  return new Promise((resolve, reject) => {
    allowToken(
      (amount) => resolve(amount),
      (err) => reject(err ?? new Error("allowance_failed"))
    );
  });
}

/**
 * allowance 是否为 0（与 invite.vue 中 res > 0 语义一致）
 * @param {string|number|import("bn.js")} raw
 */
export function isInsufficientUsdtAllowance(raw) {
  return Web3.utils.toBN(String(raw)).isZero();
}

/**
 * 若卖酒合约 USDT allowance 为零则触发 approve。
 * @returns {Promise<{ didApprove: boolean }>}
 */
export async function ensureUsdtAllowanceForSellWine() {
  const amount = await readUsdtAllowanceForSellWine();
  if (!isInsufficientUsdtAllowance(amount)) {
    return { didApprove: false };
  }
  await approveToken();
  return { didApprove: true };
}
